export default "__VITE_ASSET__CWyR1JFs__"